import { defineComponent, inject } from 'vue';

import PrivacyStatement from './PrivacyStatement.class';
import { setupComponent } from "@studyportals/vue-platform";
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';

export default defineComponent({
	props: {
		isRegister: {
			type: Boolean,
			default: false
		}
	},
	setup: (props) => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		if (!store) {
			throw new Error('IncentiveV2Store not provided');
		}
		const component = new PrivacyStatement(store, props.isRegister);
		return setupComponent(component);
	},
});
